<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2 class="center-align">Create an account</h2>
        <br>
        <div class="text-center">
          <c-button :onClick="onConnect" variant="transparent" :keepLoading="true">
            <img class="logo" src="../../public/connect-with-strava.png" width="200px">
          </c-button>
        </div>
        <br>
        <span class="failure">{{ failureMessage }}</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import { onLogin } from '../vue-apollo';
  import CButton from '@/components/Button'

  export default {
    name: 'SignUp',
    components: { CButton },
    props: {

    },
    data() {
      return {
        failureMessage: ''
      }
    },
    created() {
      if (this.user && this.user.email) this.$router.push({ name: 'Home' });
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
      isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      }
    },
    methods: {
      async onConnect(event) {
        this.failureMessage = ''

        try {
          const response = await this.$http.get(process.env.VUE_APP_API_BASE_URL + "/auth")

          if (response && response.body && response.body.authUrlWeb) {
            if (this.isMobile) {
              window.location.href = response.body.authUrlMobile;
            } else {
              window.location.href = response.body.authUrlWeb;
            }
          } else {
            throw(new Error('Could not redirect to Strava log in page'))
          }
        } catch(e) {
          this.failureMessage = e
        }
      }
    }
  }
</script>

<style scoped>

</style>
